import {DELIMITER_NOTE, DELIMITER_SMS} from "../constants/General";

// **************************************************************************************************************
export const getBillingTypeSelection = (state) => state.toggleSelections["billingType"]
export const getPostalInvoiceSelection = (state) => state.toggleSelections["invoiceType"]

// **************************************************************************************************************
export const isBillingAddressOpened = (state) => state.collapsibles["billingAddress"]
export const isContactPersonOpened = (state) => state.collapsibles["contactPerson"]

// **************************************************************************************************************
export const getRecommendedAccountTypes = (state) => state.recommendedAccountTypes

// **************************************************************************************************************
export const getCart = (state) => state.cart
export const getCartId = (state) => state.cart.id
export const getCartPaymentSettings = (state) => state.cart.paymentSettings
export const getCartPromotionCode = (state) => state.cart.promotionCode
export const getCartRecommendedAccount = (state) => state.cart.recommendedAccount
export const getCartSoftware = (state) => state.cart && state.cart.software ? state.cart.software : "default"
export const getCartDatabase = (state) => state.cart.mysqlVersion ? state.cart.mysqlVersion : false
export const getCartNote = (state) => state.cart.note ? state.cart.note.split(DELIMITER_NOTE)[0].split(DELIMITER_SMS)[0] : ""
export const getCartPhoneVerificationNote = (state) => state.cart.note ? state.cart.note.split(DELIMITER_NOTE)[1] : ""
export const getCartContractPartner = (state) => state.cart.contractPartner
export const getCartCommissionValue = (state) => state.cart.commission
export const getCartContactPerson = (state) => state.cart.contactPerson
export const getCartBillingAddress = (state) => state.cart.billingAddress
export const getCartItems = (state) => {
    if (!state || !state.cart || !state.cart.items) {
        return [];
    }
    // sort articles ascending
    return [...state.cart.items].sort((a, b) => {
        return Number(a.identifier) - Number(b.identifier);
    })
}
export const getCartVerification = (state) => state.cart.verification
export const getCartProjectPassword = (state) => state.cart && state.cart.projectPassword;
export const getCartProjectName = (state) => state.cart && state.cart.projectName;
export const getCartShowCommissionForm = (state) => state.cart && state.cart.showCommissionForm;

export const getCartBackupRange = (state) => state.cart.backupRange || 0
export const getCartTesting = (state) => (state && state.cart && state.cart.testing) || false
export const getCartAllowedForCustomerChange = state => state.cart && state.cart.isAllowedForCustomerChange

// **************************************************************************************************************
export const getInitialCartAddons = (state) => (state.cart && state.cart.initParams) ? state.cart.initParams.initialArticles : []
export const getInitialAddonLock = (state) => (state.cart && state.cart.initParams) ? state.cart.initParams.lockInitialAddons : false
export const getInitialPromotionCode = (state) => (state.cart && state.cart.initParams) ? state.cart.initParams.initialPromotionCode : false

// **************************************************************************************************************
export const getPromotionCodeInformation = (state) => state.promotionCode.codeInformation
export const isPromotionCodeValid = (state) => state.promotionCode.validatedPromotionCode

// **************************************************************************************************************
export const isAlternateSepaSelection = (state) => state.paymentStep.isAlternateSepaInput

// **************************************************************************************************************
export const getBaseArticle = (state) => state.articleData.baseArticle

// **************************************************************************************************************
export const getDomainData = (state) => state.domainCheck.topLevelDomains.data

// **************************************************************************************************************
export const getArticleOptionsData = (state) => state.articleData.articleOptions
export const getArticleOptionCollections = (state) => state.articleData.articleOptionCollection


export const getAccounts = (state) => state.accounts
export const getContracts = (state) => state.contracts
export const getResellers = (state) => state.resellers
export const getMappings = (state) => state.mappings;

export const getToggleSelections = state => state.toggleSelections



/** WEBPACK FOOTER **
 ** ./src/selectors/SimpleSelectors.js
 **/